<template>
	<div class="menu_box border_bottom_dashed" style="border-top: none;border-bottom: none;">
		<div class="flex borderBottomDashed paddingAll20 ">
			<div class="title_shaixuan flex_jc_center">筛选</div>
			<div>
				<el-form :inline="true" :model="formData" class="demo-form-inline">
					<el-form-item class="select-input">
						<el-select size="small" v-model="formData.status" placeholder="用工状态">
              <el-option label="不限" value=""/>
              <el-option v-for="(item, index) in data.status" :key="index" :label="item.desc" :value="item.type"/>
						</el-select>
					</el-form-item>
				</el-form>
			</div>
		</div>
	</div>
</template>

<script>
  import {apiFlexibleEmployment} from "@/api/apiFlexibleEmployment"
	export default {
		name: "recruitType",
    data() {
      return {
        data:{},
        formData:{
          status:'',
        }
      }
    },
    watch:{
      'formData.status':function (v){
        let obj=this.data.status.filter(d=>d.type==v);
        if(v!==''&&obj.length){
          this.send(obj[0],'status')
        }else{
          this.$parent.$refs.screen.recruitType=[]
        }
      },
    },
    created() {
		  this.getTypeAndStatus()
    },
    methods: {
      /** @name 获取用工类型和用工状态 */
      async getTypeAndStatus() {
        if(!this.$store.state.HC_recruitType){
          let res = await apiFlexibleEmployment.GetTypeAndStatus()
          this.data = res.data.data
          this.$store.state.HC_recruitType = res.data.data
        }else{
          this.data = this.$store.state.HC_recruitType
        }
      },
      /** @name 搜索单项 */
      send(obj,key){
        if(key)obj.key=key;
        //替换搜索项
        let type=-1;
        this.$parent.$refs.screen.recruitType.map((d,i)=>{
          if(d.key==key){
            type=i
          }
        });
        if(type>-1) {
          this.$parent.$refs.screen.recruitType.splice(type,1,obj)
          return
        }
        //添加搜索项
        this.$parent.$refs.screen.recruitType.push(obj)
      },
      /** @name 清队单项 */
      close(item){
        this.formData[item.key]=''
      },
      /** @name 清空所有 */
      closeall(){
        this.formData={
          status:'',
        }
      }
    },
	}
</script>

<style scoped>

</style>
